<template>
  <div style="padding: 10px">
    <el-descriptions size="small" direction="horizontal" :column="4" border>
      <el-descriptions-item>
        <template slot="label">模板标题</template>
        <el-input placeholder="请填写模板标题" size="small" v-model="singleData.sysPrintName"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">模板类型</template>
        <el-input placeholder="请填写模板类型" size="small" v-model="singleData.sysPrintType"></el-input>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">顺序</template>
        <el-input placeholder="请填写顺序" size="small" type="number" v-model="singleData.orderNum"></el-input>
      </el-descriptions-item>
    </el-descriptions>
    <div style="display: flex;flex-direction: column">
      <el-space style="margin-bottom: 10px">
        <el-button-group>
          <template v-for="(value, type) in paperTypes">
            <el-button :type="curPaperType === type ? 'primary' : ''" size="mini" style="line-height: 1.3em"
              @click="setPaper(type, value)">
              {{ type }}
            </el-button>
          </template>
          <el-popover v-model="paperPopVisible" title="设置纸张宽高(mm)" trigger="click">
            <div>
              <div style="margin: 10px 10px">
                <el-input type="number" v-model="paperWidth" size="small" style="width: 100px; text-align: center"
                  placeholder="宽(mm)" />
                --
                <el-input type="number" v-model="paperHeight" size="small"
                  style="width: 100px; text-align: center; border-left: 0" placeholder="高(mm)" />
              </div>
              <el-button size="small" style="width: 100%" @click="otherPaper">确定</el-button>
            </div>
            <el-button size="small" :type="'other' == curPaperType ? 'primary' : ''" slot="reference">自定义纸张</el-button>
          </el-popover>
        </el-button-group>
        <el-button-group style="margin: 0 10px">
          <el-button size="small" type="" icon="el-icon-plus" @click="changeScale(true)"></el-button>
          <el-button size="small" :value="scaleValue" :min="scaleMin" :max="scaleMax" :step="0.1" disabled
            style="width: 70px" :formatter="(value) => `${(value * 100).toFixed(0)}%`"
            :parser="(value) => value.replace('%', '')">{{ `${(scaleValue * 100).toFixed(0)}%` }}</el-button>
          <el-button size="small" type="" icon="el-icon-minus" @click="changeScale(false)"></el-button>
        </el-button-group>
        <el-button-group style="margin: 0 10px">
          <el-button size="small" icon="redo" @click="rotatePaper()">旋转</el-button>
          <el-button size="small" icon="eye" @click="preView"> 预览 </el-button>
          <el-button size="small" icon="printer" @click="print"> 直接打印 </el-button>
          <el-button size="small" icon="printer" @click="showJson = true">
            数据展示
          </el-button>
        </el-button-group>
        <el-select v-model="fontFamily" placeholder="请选择" style="width: 110px" size="small">
          <el-option v-for="item in fontFamilys" :key="item.value" :label="item.title" :value="item.value">
          </el-option>
        </el-select>
        <el-button size="small" @click="updateFontFamily"> 字体 </el-button>
        <el-color-picker v-model="fontColor" show-alpha :predefine="predefineColors" style="top:11.75px"
          class="margin-left-xs" size="small" />
        <el-button size="small" @click="updateFontColor"> 字体颜色 </el-button>
        <!-- <el-button size='small' @click="onlyPrint">
            Api单独打印
          </el-button>
          <el-button size='small' @click="onlyPrint2">
            Api单独直接打印
          </el-button>  -->
        <el-button-group style="margin: 0 10px">
          <el-button size="small" type="danger" @click="clearPaper"> 清空 </el-button>
          <el-button size="small" type="success" @click="savePaper"> 保存 </el-button>
        </el-button-group>
        <div style="
            display: inline-block;
            grid-column-start: 2;
            grid-column-end: 99;
            height: 16;
            border-bottom: 1px solid #444;
          "></div>
        <el-button size="small" type="info" @click="goBack"> 返回 </el-button>
        <!-- <json-view :template="template"/> -->
      </el-space>
      <el-space>
        <el-button-group style="margin: 0 0 10px 0px">
          <div class="mo-input--number">
            <el-input-number v-model="fontSize" placeholder="请输入" style="width: 80px" size="small"
              controls-position="right" clearable>
            </el-input-number>
            <div class="define-append">pt</div>
          </div>
        </el-button-group>
        <el-button-group style="margin: 0 0 10px 0px">
          <el-button type="primary" size="small" @click="updateFontSize">
            大小
          </el-button>
          <el-button type="primary" size="small" @click="updateLineHeight">
            行高
          </el-button>
          <el-button type="primary" size="small" @click="updateLetterSpacing">
            间隔
          </el-button>
          <el-button type="primary" size="small" @click="updateFontWeight">
            粗体
          </el-button>
          <el-button type="primary" size="small" @click="setElsSpace(true)">
            水平间距
          </el-button>
          <el-button type="primary" size="small" @click="setElsSpace(false)">
            垂直间距
          </el-button>
        </el-button-group>

        <el-button-group style="margin: 0 10px 10px 10px">
          <el-button @click="setElsAlign('left')" size="small" title="左对齐">
            <span class="glyphicon glyphicon-object-align-left">左对齐</span>
          </el-button>
          <el-button @click="setElsAlign('vertical')" size="small" title="居中">
            <span class="glyphicon glyphicon-object-align-vertical">居中</span>
          </el-button>
          <el-button @click="setElsAlign('right')" size="small" title="右对齐">
            <span class="glyphicon glyphicon-object-align-right">右对齐</span>
          </el-button>
          <el-button @click="setElsAlign('top')" size="small" title="顶部对齐">
            <span class="glyphicon glyphicon-object-align-top">顶部对齐</span>
          </el-button>
          <el-button @click="setElsAlign('horizontal')" size="small" title="垂直居中">
            <span class="glyphicon glyphicon-object-align-horizontal">垂直居中</span>
          </el-button>
          <el-button @click="setElsAlign('bottom')" size="small" title="底部对齐">
            <span class="glyphicon glyphicon-object-align-bottom">底部对齐</span>
          </el-button>
          <el-button @click="setElsAlign('distributeHor')" size="small" title="横向分散">
            <span class="glyphicon glyphicon-resize-horizontal">横向分散</span>
          </el-button>
          <el-button @click="setElsAlign('distributeVer')" size="small" title="纵向分散">
            <span class="glyphicon glyphicon-resize-vertical">纵向分散</span>
          </el-button>
        </el-button-group>
      </el-space>
    </div>
    <el-row :gutter="[8, 0]">
      <el-col :span="4">
        <el-card style="height: calc(100vh - 225px)">
          <el-row>
            <el-select v-model="mode" showSearch @change="changeMode(1)" size="small" :defaultValue="0"
              option-label-prop="label" style="width: 100%">
              <el-option v-for="(opt, idx) in modeList" :key="idx" :label="opt.name" :value="idx">
                {{ opt.name }}
              </el-option>
            </el-select>
          </el-row>
          <el-row>
            <el-col :span="24" class="rect-printElement-types hiprintEpContainer">
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="15">
        <el-card class="card-design">
          <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
        </el-card>
      </el-col>
      <el-col :span="5" class="params_setting_container">
        <el-card>
          <el-row class="hinnn-layout-sider" style="min-height: calc(100vh - 255px)">
            <div id="PrintElementOptionSetting"></div>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <!-- 预览 -->
    <print-preview ref="preView" />
    <el-dialog :visible.sync="showJson" :close-on-click-modal="false" class="dialog" :width="'900px'"
      @close="showJson = false">
      <div style="margin-bottom: 10px">
        <el-input type="textarea" style="width: 850px" v-model="jsonIn" @pressEnter="updateJson" clearable
          :autosize="{ minRows: 8, maxRows: 10 }" placeholder="复制json模板到此后 点击右侧更新" allow-clear />
        <el-button type="primary" @click="exportJson" style="margin-top: 10px">
          导出json模板到 textArea
        </el-button>
        <el-button type="primary" @click="
          jsonIn = '';
        jsonOut = '';
        " style="margin-top: 10px">
          清空
        </el-button>
        <el-button type="primary" @click="updateJson" style="margin-top: 10px">
          更新json模板
        </el-button>
      </div>
      <el-input type="textarea" style="width: 850px" v-model="jsonOut" clearable placeholder="点击左侧导出json"
        :autosize="{ minRows: 8, maxRows: 10 }" allow-clear />
      测试数据
      <el-input type="textarea" style="width: 850px" v-model="singleData.remark" clearable placeholder="点击左侧导出json"
        :autosize="{ minRows: 8, maxRows: 10 }" allow-clear />
    </el-dialog>
  </div>
</template>

<script defer>
// import hiprintBundle from "./hiprint/hiprint.bundle";
import { sysPrint_update, sysPrint_add } from '@/api/myController/system';
import { defaultElementTypeProvider, hiprint } from 'vue-plugin-hiprint';
// import panel from './panel'
import printPreview from './preview';
import providers from './providers';
// import jsonView from "../json-view.vue";
import scale from './scale.js';
import { decodeVer } from '@/utils';
import { createNormalizedHiprintTemplate } from '@/utils/printTemplatePaper';
let hiprintTemplate;
// disAutoConnect();
var panel;
var printData;
export default {
  name: 'print_printSystem',
  components: { printPreview },
  data() {
    return {
      template: null,
      showJson: false,
      fontSize: 12,
      singleData: {
        remark: ''
      },
      fontColor: '#666',
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      jsonIn: '',
      fontFamily: 'Microsoft YaHei',
      fontFamilys: [
        { title: '微软雅黑', value: 'Microsoft YaHei' },
        { title: '黑体', value: 'STHeitiSC-Light' },
        { title: '思源黑体', value: 'SourceHanSansCN-Normal' },
        { title: '王羲之书法体', value: '王羲之书法体' },
        { title: '宋体', value: 'SimSun' },
        { title: '楷体', value: 'Kaiti' },
        { title: 'cursive', value: 'cursive' }
      ],
      jsonOut: '',
      treeNode: {},
      // 模板选择
      mode: 0,
      modeList: [],
      // 当前纸张
      curPaper: {
        type: 'A4',
        width: 210,
        height: 296.6
      },
      // 纸张类型
      paperTypes: {
        A3: {
          width: 420,
          height: 296.6
        },
        A4: {
          width: 210,
          height: 296.6
        },
        A5: {
          width: 210,
          height: 148
        },
        B3: {
          width: 500,
          height: 352.6
        },
        B4: {
          width: 250,
          height: 352.6
        },
        B5: {
          width: 250,
          height: 175.6
        }
      },
      scaleValue: 1,
      scaleMax: 5,
      scaleMin: 0.5,
      // 自定义纸张
      paperPopVisible: false,
      paperWidth: '210',
      paperHeight: '296.6',
      lastjson: ''
    };
  },
  computed: {
    curPaperType() {
      let type = '';
      let types = this.paperTypes;
      let id = 0;
      for (const key in types) {
        id++;
        let item = types[key];
        let { width, height } = this.curPaper;
        if (item.width === width && item.height === height) {
          type = key;
        }
        if (id == 6 && !type) {
          type = 'other';
        }
      }
      return type;
    }
  },
  mounted() {
    var singleData = this.$route.query.singleData;
    singleData.remark = singleData?.remark || '{}';
    this.singleData = singleData || {};
    this.singleData.remark = this.singleData.remark || '{}';
    try {
      this.singleData.remark = JSON.stringify(
        JSON.parse(this.singleData.remark),
        null,
        2
      );
    } catch (error) { }
    printData = this.singleData.remark || '[]';
    this.treeNode = this.$route.query.treeNode || {};
    this.detailsType = this.$route.query.detailsType || 1;
    this.singleData.printTemplateDetails = this.singleData.printTemplateDetails || '{}';
    this.getPanel();
  },
  methods: {
    async init() {
      this.modeList = providers.map((e) => {
        return { type: e.type, name: e.name, value: e.value };
      });
      try {
        var curPaper = { height: panel.panels[0].height, width: panel.panels[0].width };
        var id = 1;
        for (const type in this.paperTypes) {
          id++;
          const { width, height } = this.paperTypes[type];
          if (curPaper.width === width && curPaper.height === height) {
            curPaper.type = type;
            this.curPaper = curPaper;
          }
          if (id == 6 && !curPaper.type) {
            curPaper.type = 'other';
            this.curPaper = curPaper;
          }
        }
      } catch (error) {
        console.warn('错误信息', error);
      }
      this.changeMode();
    },
    getPanel() {
      // 加载所有 panel
      const panels = require.context('./', true, /panel.*\.js$/);
      // 对所有 panel 进行版本解析
      var panelInfos = panels.keys().map((key) => ({
        ...decodeVer(key.replace(/(\.\/panel-?)|(\.js)/g, '')),
        key
      }));
      // 存在一个固定版本号，并且不是开发版本
      if (this.$parent.version && this.$parent.version != 'development') {
        // 解析对应版本信息
        var currVerInfo = decodeVer(this.$parent.version);
        // 查找小于等于当前版本的 panel
        var newVers = panelInfos
          .filter(({ verVal }) => verVal <= currVerInfo.verVal)
          // 对版本号进行倒叙
          .sort((acc, curr) => curr.verVal - acc.verVal);
        // 获取最大版本号面板 json
        panel = panels(newVers[0].key).default;
        this.init();
      }
      // 不存在固定版本，加载默认面板 json
      else {
        try {
          var printTemplateDetails = JSON.parse(this.singleData.printTemplateDetails)
          console.log('this.singleData.printTemplateDetails', printTemplateDetails)
          this.paperHeight = printTemplateDetails.panels[0].height
          this.paperWidth = printTemplateDetails.panels[0].width
        } catch (error) { }
        panel =
            printTemplateDetails ||
            panels('./panel.js').default;
        this.init();
      }
    },
    changeMode(_) {
      let { mode } = this;
      let provider = providers[mode];
      hiprint.init({
        providers: [provider.f]
      });
      $('.hiprintEpContainer').empty();
      hiprint.PrintElementTypeManager.build('.hiprintEpContainer', provider.value);
      $('#hiprint-printTemplate').empty();
      if (hiprintTemplate && _) {
        panel = hiprintTemplate.getJson() || panel;
      }
      this.template = hiprintTemplate = new hiprint.PrintTemplate({
        template: panel,
        dataMode: 1, // 1:getJson 其他：getJsonTid 默认1
        history: false, // 是否需要 撤销重做功能
        fontList: [
          { title: '微软雅黑', value: 'Microsoft YaHei' },
          { title: '黑体', value: 'STHeitiSC-Light' },
          { title: '思源黑体', value: 'SourceHanSansCN-Normal' },
          { title: '王羲之书法体', value: '王羲之书法体' },
          { title: '宋体', value: 'SimSun' },
          { title: '楷体', value: 'Kaiti' },
          { title: 'cursive', value: 'cursive' }
        ],
        onDataChanged: (type, json) => {
          // 更新模板
          // hiprintTemplate.update(json)
        },

        settingContainer: '#PrintElementOptionSetting',
        paginationContainer: '.hiprint-printPagination'
      });
      hiprintTemplate.design('#hiprint-printTemplate', { grid: true });
      // 获取当前放大比例, 当zoom时传true 才会有
      this.scaleValue = hiprintTemplate.editingPanel.scale || 1;
    },
    setElsAlign(e) {
      hiprintTemplate.setElsAlign(e);
    },
    setElsSpace(h) {
      hiprintTemplate.setElsSpace(this.fontSize, h);
    },
    getSelectEls() {
      let els = hiprintTemplate.getSelectEls();
    },
    updateLineHeight() {
      hiprintTemplate.updateOption('lineHeight', this.fontSize);
    },
    updateLetterSpacing() {
      hiprintTemplate.updateOption('letterSpacing', this.fontSize);
    },
    updateFontSize() {
      hiprintTemplate.updateOption('fontSize', this.fontSize);
    },
    updateFontFamily() {
      hiprintTemplate.updateOption('fontFamily', this.fontFamily);
    },
    updateFontColor() {
      hiprintTemplate.updateOption('color', this.fontColor);
    },

    updateFontWeight() {
      let els = hiprintTemplate.getSelectEls();
      var bolder = 'bolder';
      if (els.length > 0) {
        bolder = els[0].options.fontWeight;
      }
      bolder = bolder ? undefined : 'bolder';
      hiprintTemplate.updateOption('fontWeight', bolder);
    },
    /**
     * 设置纸张大小
     * @param type [A3, A4, A5, B3, B4, B5, other]
     * @param value {width,height} mm
     */
    setPaper(type, value) {
      try {
        if (Object.keys(this.paperTypes).includes(type)) {
          this.curPaper = { type: type, width: value.width, height: value.height };
          hiprintTemplate.setPaper(value.width, value.height);
        } else {
          this.curPaper = {
            type: 'other',
            width: parseFloat(value.width),
            height: parseFloat(value.height)
          };
          hiprintTemplate.setPaper(value.width, value.height);
        }
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    },
    changeScale(big) {
      let scaleValue = this.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.scaleMin) scaleValue = 0.5;
      }
      if (hiprintTemplate) {
        // scaleValue: 放大缩小值, false: 不保存；true 会写入模板，打印时字段错位
        hiprintTemplate.zoom(scaleValue, false);
        this.scaleValue = scaleValue;
      }
    },
    otherPaper() {
      let value = {};
      value.width = this.paperWidth;
      value.height = this.paperHeight;
      this.paperPopVisible = false;
      this.setPaper('other', value);
    },
    preView() {
      let data = {};
      try {
        data = JSON.parse(this.singleData.remark || '{}');
      } catch (e) {
        data = {};
      }
      const rows = Array.isArray(data) ? data : [data];
      const json =
        hiprintTemplate && typeof hiprintTemplate.getJson === 'function'
          ? hiprintTemplate.getJson()
          : null;
      const printTpl = createNormalizedHiprintTemplate(json || hiprintTemplate);
      this.$refs.preView.show(printTpl, rows, this.curPaper && this.curPaper.width);
    },
    print() {
      let data = {};
      try {
        data = JSON.parse(this.singleData.remark || '{}');
      } catch (e) {
        data = {};
      }
      const json =
        hiprintTemplate && typeof hiprintTemplate.getJson === 'function'
          ? hiprintTemplate.getJson()
          : null;
      const printTpl = createNormalizedHiprintTemplate(json || hiprintTemplate);
      printTpl.print2(data, { printer: '', title: 'hiprint测试打印' });
    },
    rotatePaper() {
      if (hiprintTemplate) {
        hiprintTemplate.rotatePaper();
      }
    },
    clearPaper() {
      try {
        hiprintTemplate.clear();
      } catch (error) {
        this.$message.error(`操作失败: ${error}`);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    savePaper() {
      const printerList = hiprintTemplate.getPrinterList();
      let json = this.tidMode ? this.template.getJsonTid() : this.template.getJson();
      let jsonOut = JSON.stringify(json, null, 0);

      if (!this.singleData.sysPrintName) {
        this.$message.warning('模板标题为空');
        return;
      }
      if (!this.singleData.sysPrintType) {
        this.$message.warning('模板类型为空');
        return;
      }
      if (this.detailsType == 1) {
        let json = {
          sysPrintId: this.singleData.sysPrintId,
          modules: this.treeNode.modules,
          orderNum: this.singleData.orderNum,
          printTemplateDetails: jsonOut,
          printTimes: 0,
          remark: this.singleData.remark,
          sysPrintName: this.singleData.sysPrintName,
          sysPrintType: this.singleData.sysPrintType,
          isDefault: 1
        };
        sysPrint_add({ sysPrintDto: json }).then((res) => {
          this.detailsType = 2;
          this.singleData.sysPrintId = res.data.data;
          this.$message.success('操作成功！');
          // this.$router.go(-1)
        });
      } else {
        let json = {
          sysPrintId: this.singleData.sysPrintId,
          modules: this.treeNode.modules,
          orderNum: this.singleData.orderNum,
          printTemplateDetails: jsonOut,
          printTimes: this.singleData.printTimes,
          remark: this.singleData.remark,
          sysPrintName: this.singleData.sysPrintName,
          sysPrintType: this.singleData.sysPrintType,
          isDefault: this.singleData.isDefault
        };
        sysPrint_update({ sysPrintDto: json }).then((res) => {
          this.$message.success('操作成功！');
          // this.$router.go(-1)
        });
      }
    },
    updateJson() {
      if (hiprintTemplate) {
        try {
          hiprintTemplate.update(JSON.parse(this.jsonIn));
          this.$message.success('更新成功');
        } catch (e) {
          this.$message.error(`更新失败: ${e}`);
        }
      }
    },
    exportJson() {
      if (hiprintTemplate) {
        this.jsonOut = JSON.stringify(hiprintTemplate.getJson() || {}, null, 2);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-input-number__decrease {
  width: 20px;
}

// build 拖拽
/deep/ .hiprint-printElement-type>li>ul>li>a {
  padding: 4px 4px;
  color: #1476c3;
  line-height: 1;
  height: auto;
  text-overflow: ellipsis;
}

// 默认图片
/deep/ .hiprint-printElement-image-content {
  img {
    content: url("~@/assets/img/none.png");
  }
}

// 设计容器
.card-design {
  overflow: hidden;
  overflow-x: auto;
  overflow-y: auto;
}
</style>

<style lang="scss" scoped>
/* 自定义数字输入框append  */
.mo-input--number {
  border: 1px solid #dcdfe6;
  width: 100%;
  display: flex;
  border-radius: 4px;

  .el-input-number--mini {
    flex: 1;
  }

  ::v-deep .el-input__inner {
    border: none !important;
  }
}

.define-append {
  width: 20px;
  display: inline-block;
  background: #f5f7fa;
  padding: 0px 3px;
  border-left: none;
  height: 32px;
  line-height: 32px;
  color: #909399;
  font-size: 12px;
  text-align: center;
}
</style>
